import Box from '@mui/material/Box';
import { SectionTitle, BodyText } from '../components/SectionPrimitives';
import { color } from '@/themes/color';
import { typography } from '@/themes/typography';

export function Section5(): JSX.Element {
  return (
    <Box>
      <SectionTitle>5. Limitation of Liability</SectionTitle>
      <BodyText>
        To the fullest extent permitted by applicable law, UKVG's total
        aggregate liability to the Partner under or in connection with the
        Agreement, whether arising in contract, tort (including negligence),
        breach of statutory duty, or otherwise, shall not exceed the total fees
        paid by the Partner in the 12-month period immediately preceding the
        event giving rise to the claim.
      </BodyText>
      <BodyText>UKVG shall not be liable to the Partner for any:</BodyText>
      <Box
        component="ul"
        sx={{
          ...typography.bodyText,
          display: 'block',
          marginTop: 0,
          marginBottom: '24px',
          color: color.charcoal.default,
        }}
      >
        {[
          'loss of revenue, profit, or anticipated savings;',
          'loss of business, contracts, or commercial opportunity;',
          'loss of goodwill or reputational damage;',
          'indirect, special, or consequential loss or damage of any kind;',
          'loss arising from the actions or omissions of third-party platforms, booking systems, or payment processors integrated with or linked from the platform.',
        ].map((item) => (
          <li key={item} style={{ marginBottom: '8px', lineHeight: '1.7' }}>
            {item}
          </li>
        ))}
      </Box>
    </Box>
  );
}
